import { Paragraph, Headline, Link, Image } from 'Common';
import { balloonie, mobile } from 'images/PromotionalBanner/ClosingBanner';
import { PromotionalBanner } from 'components/Component';
import { colors } from 'components/Theme';

export const BalloonClosingBanner = () => {
  const backgroundColor = colors.blue.c800;

  return (
    <PromotionalBanner
      backgroundColor={backgroundColor}
      ariaLabel="Balloon wird am 30.09.2026 eingestellt"
      leftImage={<Image src={balloonie} className="left-image bf-balloonie" alt="Eine Figur geht einkaufen" />}
      mobileImage={<Image src={mobile} className="mobile-image bf-mobile-image" alt="Eine Figur geht einkaufen" />}
    >
      <Headline level={2}>Balloon wird am 30.09.2026 eingestellt</Headline>
      <Paragraph>
        Bei Fragen dazu wende dich an{' '}
        <Link aria-label="sende eine E-Mail an info@balloonapp.de" href="mailto:info@balloonapp.de" color={colors.white.c500}>
          info@balloonapp.de
        </Link>
        .
      </Paragraph>
    </PromotionalBanner>
  );
};
